import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-federation-of-blind',
  templateUrl: './national-federation-of-blind.component.html',
  styleUrls: ['./national-federation-of-blind.component.scss']
})
export class NationalFederationOfBlindComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
